import { useUser } from '../context/userContext';
import { getRoles } from '../roleAndPermissions/getRoles';

const useUserRole = () => {
    const { userType } = useUser();
    if (userType === 'superadmin') return getRoles('superadmin');
    if (userType === 'admin') return getRoles('admin');
    return { create: false, edit: false, hide: [] };
};

export default useUserRole;